import { render, staticRenderFns } from "./naj-loader.vue?vue&type=template&id=d9bf2b70&scoped=true&"
import script from "./naj-loader.vue?vue&type=script&lang=js&"
export * from "./naj-loader.vue?vue&type=script&lang=js&"
import style0 from "./naj-loader.vue?vue&type=style&index=0&id=d9bf2b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bf2b70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
